const unleashFeatureFlags = {
  Guardians1586Maintenance: 'guardians_1586_maintenance-safebrok-europe',
};

export default unleashFeatureFlags;
